export const availablePeriodsApi = '/api/v1/schedules/available_period/';
